import React from 'react';

import { Select } from '@veneer/core';

import ThemeProviderWrapper from '../../utils/ThemeProviderWrapper/ThemeProviderWrapper';
import { ProductOptions, SelectedOption } from './types';
import { SelectContainer } from './styles';
interface PrinterSelectProps {
  printerColumn: number;
  options: ProductOptions[];
  selectedArray: string[];
  onChange: (selectedOption: SelectedOption, column: number) => void;
}

const PrinterSelect: React.FC<PrinterSelectProps> = ({
  printerColumn,
  options,
  selectedArray,
  onChange,
}) => {
  const selectedOption = options.find(
    (option) => option.value === selectedArray[printerColumn]
  );

  const handleOnChange = (option: SelectedOption) => {
    onChange(option, printerColumn);
  };

  const handleOnClear = () => {
    onChange({ value: '' }, printerColumn);
  };

  return (
    <ThemeProviderWrapper>
      <SelectContainer>
        <Select
          options={options}
          id={`select-printer-${printerColumn}`}
          data-testid={`selectElement-${printerColumn}`}
          label=""
          clearIcon={false}
          placement="bottom"
          helperTextVisibility="auto"
          onChange={handleOnChange}
          onClear={handleOnClear}
          value={selectedOption ? [selectedOption.value] : []}
        />
      </SelectContainer>
    </ThemeProviderWrapper>
  );
};

export default PrinterSelect;
